import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const OrangeIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-orange"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M46,20 C46,26.627 40.627,32 34,32 C27.373,32 22,26.627 22,20 C22,13.373 27.373,8 34,8 C40.627,8 46,13.373 46,20"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M34,7 C26.8207153,7 21,12.8207153 21,20 C21,27.1792847 26.8207153,33 34,33 C41.1792847,33 47,27.1792847 47,20 C47,12.8207153 41.1792847,7 34,7 Z M34,9 C40.0747153,9 45,13.9252847 45,20 C45,26.0747153 40.0747153,31 34,31 C27.9252847,31 23,26.0747153 23,20 C23,13.9252847 27.9252847,9 34,9 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M40.3543,17.1194 C36.8393,20.6344 36.8393,26.3324 40.3543,29.8474 C43.8693,33.3624 49.5673,33.3624 53.0823,29.8474 L40.3543,17.1194 Z"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M54.4965136,29.8474 L40.3543,15.7051864 L39.6471932,16.4122932 C35.7416689,20.3178175 35.7416689,26.6489825 39.6471932,30.5545068 C43.5527175,34.4600311 49.8838825,34.4600311 53.7894068,30.5545068 L54.4965136,29.8474 Z M40.399,18.578 L51.623,29.802 L51.5376843,29.8701391 C48.4026721,32.242138 43.9199697,31.9988561 41.0614068,29.1402932 C38.2028439,26.2817303 37.959562,21.7990279 40.3315609,18.6640157 L40.399,18.578 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M33.6857,3.1893 C34.8577,4.3613 34.7147,5.6323 34.7467,6.3713 C34.0067,6.3393 32.7357,6.4823 31.5647,5.3103 C30.3927,4.1393 30.5357,2.8683 30.5037,2.1283 C31.2427,2.1603 32.5137,2.0173 33.6857,3.1893"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M39.0392,4.4142 C37.4772,5.9762 35.7822,5.7852 34.7962,5.8282 C34.8392,4.8432 34.6482,3.1482 36.2112,1.5862 C37.7732,0.0232 39.4682,0.2142 40.4532,0.1712 C40.4102,1.1572 40.6012,2.8522 39.0392,4.4142"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="35 5 35 11 34 11 34 5"
        />
        <path
          d="M36,11.5 C36,12.328 35.328,13 34.5,13 C33.672,13 33,12.328 33,11.5 C33,10.672 33.672,10 34.5,10 C35.328,10 36,10.672 36,11.5"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="47 24 47 33 46 33 46 24"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="46 23 46 24 37 24 37 23"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          points="46.328 22.964 47.036 23.672 40.672 30.036 39.964 29.328"
        />
        <path
          d="M29 25C29 25.552 28.552 26 28 26 27.448 26 27 25.552 27 25 27 24.448 27.448 24 28 24 28.552 24 29 24.448 29 25M27 18C27 18.552 26.552 19 26 19 25.448 19 25 18.552 25 18 25 17.448 25.448 17 26 17 26.552 17 27 17.448 27 18M31 21C31 21.552 30.552 22 30 22 29.448 22 29 21.552 29 21 29 20.448 29.448 20 30 20 30.552 20 31 20.448 31 21"
          fill="#00000"
          className={styles.defaultColor}
        />
      </g>
    </Icon>
  )
}
